<template>
  <div class="container">
    <div class="header">
      <van-row class="type-wrap">
        <van-col span="20">
          <van-search
            v-model="hostUnit"
            placeholder="搜索直播名称或活动主办方名称"
            @search="searchTap"
            @clear="searchTap"
          />
        </van-col>
        <van-col span="4">
          <div @click="lookTap" class="enroll">
            <van-image
              width="15"
              height="15"
              class="banner-img"
              :src="require('@/assets/images/enroll.png')"
              fit="cover"
            />
            <div>报名</div>
          </div>
        </van-col>
      </van-row>
      <van-row class="type-wrap">
        <van-col span="12" @click="addressTap">
          <span>{{ addressText ? addressText : '区域' }}</span>
          <van-icon name="play" />
        </van-col>
        <van-col span="12" @click="typeTap">
          <span>{{ typeText ? typeText : '类型' }}</span>
          <van-icon name="play" />
        </van-col>
      </van-row>
    </div>
    <van-list
      v-if="listShow"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="10"
      @load="onLoad"
    >
      <list-com v-for="(item, i) in lists" :key="i" :item="item"></list-com>
    </van-list>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无数据"
    />
    <!-- 区域选择弹窗 -->
    <van-popup v-model="addressPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="addressColumns"
        value-key="county"
        @cancel="addressPicker = false"
        @confirm="addressConfirm"
      />
    </van-popup>
    <!-- 类型选择弹窗 -->
    <van-popup v-model="typePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @cancel="typePicker = false"
        @confirm="typeConfirm"
      />
    </van-popup>
    <van-grid :column-num="5" :border="false">
      <van-grid-item
        v-for="(item, i) in tabs"
        :key="i"
        :icon="item.icon"
        :text="item.title"
        @click="tabTap(item.url)"
      />
    </van-grid>
  </div>
</template>
<script>
import listCom from './components/listCom'
import { listLiveData, getArea, getLiveTypeList } from '@api/lishui/live'
import { Toast } from 'vant'
import { saveRecord, saveUVRecord } from '@api/lishui/live'
export default {
  components: {
    listCom
  },
  data() {
    return {
      hostUnit: '',
      loading: true,
      finished: false,
      address: '', // 区域
      addressText: '',
      type: '', // 类型
      typeText: '',
      addressPicker: false,
      addressColumns: [],
      typePicker: false,
      typeColumns: [],
      // 视频列表
      listShow: true,
      lists: [],
      pageSize: 10,
      pageNum: 1,
      // 标签栏
      tabs: [
        {
          icon: require('../../../assets/tab0.png'),
          title: '首页',
          url: '/live/index'
        },
        {
          icon: require('../../../assets/tab1.png'),
          title: '直播预告',
          url: '/live/notice'
        },
        {
          icon: require('../../../assets/tab2.png'),
          title: '正在直播',
          url: '/live/broadcast'
        },
        {
          icon: require('../../../assets/tab3.png'),
          title: '回看',
          url: '/live/playback'
        },
        {
          icon: require('../../../assets/tab4.png'),
          title: '博小益说法',
          url: '/live/statement'
        }
      ],
    }
  },
  mounted() {
    this.getLiveType()
    this.getAreaList()
    this.getList()
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => {})
      saveUVRecord(params).then(res => {})
    },
    // 跳转报名列表
    lookTap() {
      this.buriedPoint()
      this.$router.push({
        path: '/live/myCollection'
      })
    },
    getLiveType() {
      getLiveTypeList().then(res => {
        let arr = res.data.data.map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
        this.typeColumns = [{ value: '', text: '全部' }, ...arr]
      })
    },
    getAreaList() {
      getArea().then(res => {
        this.addressColumns = [
          {
            code: '',
            county: '全部'
          },
          ...res.data.data
        ]
      })
    },
    getList(num) {
      if (num) {
        this.pageNum = num
        this.lists = []
      }
      const params = {
        hostUnit: this.hostUnit,
        liveStatus: 0,
        liveType: this.type,
        areaCode: this.address,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      listLiveData(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          if (data.results) {
            data.results.forEach(item => {
              switch (item.liveStatus) {
                case 0:
                  item.statusText = '未开始'
                  break
                case 1:
                  item.statusText = '进行中'
                  break
                case 2:
                  item.statusText = '已结束'
                  break
              }
              this.lists.push(item)
            })
          }
          this.loading = false
          if (!data.results || data.results.length < 10) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.lists.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    // 搜索
    searchTap(e) {
      this.getList(1)
    },
    // 触底加载更多
    onLoad() {
      this.pageNum++
      this.getList()
    },
    addressTap() {
      this.addressPicker = true
    },
    // 区域切换
    addressConfirm(e) {
      this.address = e.code
      this.addressText = e.county
      this.getList(1)
      this.addressPicker = false
    },
    typeTap() {
      this.typePicker = true
    },
    // 类型切换
    typeConfirm(e) {
      this.type = e.value
      this.typeText = e.text
      this.getList(1)
      this.typePicker = false
    },
    // 点击标签跳转
    tabTap(url) {
      this.buriedPoint()
      this.$router.push({
        path: url
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  padding-bottom: 2.13333rem;
  background: #fff;
}
.header {
  z-index: 10;
  position: sticky;
  top: 0;
  .enroll {
    font-size: 12px;
  }
}
.van-search {
  padding: 0 0 0 0.4rem;

  .van-search__content {
    border-radius: 20px;
  }
  /deep/.van-cell__value {
    padding: 0 4px;
  }
}
.type-wrap {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eee;
  .van-col {
    text-align: center;
    padding: 8px 0;
    span {
      font-size: 14px;
    }
    .van-icon {
      font-size: 14px;
      color: #ccc;
      transform: rotate(90deg);
      margin-left: 4px;
    }
  }
}
/deep/.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
  margin-top: 20%;
}
/deep/.van-grid {
  position: fixed;
  border-top: 1px solid #eee;
  width: 100%;
  bottom: 0;
  z-index: 100;
}
/deep/.van-grid-item__content {
  padding: 12px 0 8px;
}
/deep/.van-grid-item__icon {
  font-size: 30px;
}
/deep/.van-grid-item__text {
  font-size: 14px;
  margin-top: 2px;
}
</style>
